import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-thought-record-question-quantitative-list-add-element',
    templateUrl: 'add-element.modal.html',
    styleUrls: ['add-element.modal.scss']
})
export class AddElementModal {

    @Input() options: { key: string, label: string }[];

    constructor(private modalController: ModalController) {
    }

    dismiss() {
        this.modalController.dismiss();
    }

    selectOption(option: { key: string, label: string }) {
        this.modalController.dismiss(option);
    }
}
